import Vue from 'vue';
import App from './App.vue';
import router from './router';

if (process.env.NODE_ENV !== 'production') {
    require('/Users/lu/Projects/Websites/StorrorParkour/v2/storror-ui-static/src/styles/main.scss');
    // import '/Users/benthomson/Desktop/Work/Prompt/storror-ui/src/styles/main.scss';
}

import VueCurrencyFilter from 'vue-currency-filter';
Vue.use(VueCurrencyFilter, {
    symbol: '£',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false,
});

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App),
}).$mount('#shop-app');
